export default {
  shinkansen: {
    title: 'Book Japan Shinkansen Tickets Online | Triplabo',
    caption: 'Japan Bullet Train - Shinkansen reservation',
    description:
      'Officially Authorized Partner, Pre-book popular Shinkansen lines, no need to queue, just scan QR code and go!',
    departure: 'Departure',
    arrival: 'Arrival',
    departureDate: 'Departure Date',
    ticketType: 'Shinkansen Ticket',
    earliestTime: 'Earliest Time',
    latestTime: 'Latest Time',
    travelTime: 'Travel Time',
    attractions: 'Attractions',
    stock: {
      sufficient: 'Available',
      limited: 'Limited',
      soldOut: 'Sold Out'
    },
    book: {
      reserve: 'Book',
      selectSeat: 'Select Seat'
    },
    preference: {
      earliestDeparture: 'Earliest Departure',
      fastestArrival: 'Fastest Arrival',
      lowestPrice: 'Lowest Price'
    },
    popularRoutes: {
      title: 'Popular Routes',
      jr: {
        name: 'JR',
        description:
          'JR (Japan Railways) is the official operator of the Shinkansen. Tickets purchased here are issued in partnership with JR, ensuring authenticity and reliability.'
      },
      qr: {
        name: 'QR Code',
        description:
          'Instant ticketing with QR code. Scan your QR code at the gate for quick entry.'
      },
      reserve: {
        name: 'Reserve',
        description:
          'Reserve your tickets in advance with flexible cancellation policies for peace of mind and convenience.'
      }
    },
    usageInstructions: {
      title: 'Usage Instructions',
      step1: {
        title: 'Book Your Shinkansen Ticket Online and Get a QR Code',
        description:
          '*According to JR regulations, Shinkansen tickets can only be issued within 1 month before departure.'
      },
      step2: {
        title: 'Scan Your QR Code at the Platform to Board',
        description:
          '*If you see an error, simply show your QR code to a station staff member.'
      },
      step3: {
        title: 'Locate Your Platform and Train',
        description:
          '*Passengers with unreserved seats must board unreserved cars. Seating is on a first-come, first-served basis.'
      }
    },
    duration: {
      hoursAndMinutes: '{{hours}}h {{minutes}}m',
      minutes: '{{minutes}}m',
      approximately: 'Approx. {{duration}}'
    },
    tags: {
      shinkansen: 'Shinkansen',
      qrcode: 'QR Code'
    },
    faq: {
      q1: 'How to use the Shinkansen ticket?',
      a1: 'The Shinkansen ticket is an electronic ticket that can be used directly with a QR code. After payment, the system will book the ticket in real time on the Shinkansen official platform, and the QR code ticket will be displayed in the order ticket of the mini program, and sent to the email address you provided during registration. Please confirm the information of the QR code ticket received before departure. When purchasing multiple tickets, you will receive multiple QR code tickets, one code per person, the QR code can only be scanned once, please note.',
      q2: 'What should I do if I miss the train?',
      a2: 'If you miss the Shinkansen, you can directly take another train with a free seat on the same day without refunding the ticket. If you want to ensure a seat, you can purchase a new reserved seat ticket at the station, but the previous ticket cannot be cancelled or refunded.',
      q3: 'How much luggage can I bring?',
      a3: 'You can bring up to 250cm in total, otherwise it may not be possible to carry it on the train. The luggage rack in the car: Each car has a luggage rack above it, which can hold medium-sized carry-on luggage and backpacks. The space in front of the seat: You can also use the space in front of the seat to place small luggage (will squeeze the leg space). The luggage area at the end of the car: Some trains have a larger luggage storage area at the end of the car (the last car or near the restroom), which can hold large luggage, but the space is limited, first come, first served. *It is not allowed to put luggage boxes on the aisle or between seats, as it may affect other passengers passing by.'
    }
  }
};
